import * as THREE from 'three'
import Experience from './Experience.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

export default class Camera
{
    constructor()
    {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas

        this.setInstance()
        // this.setControls()
    }

    setInstance()
    {
        this.instance = new THREE.PerspectiveCamera(35, this.sizes.width / this.sizes.height, 0.1, 100)
        this.updateCameraPosition()
        this.scene.add(this.instance)
    }

    updateCameraPosition()
    {
        // Adjust camera X position based on aspect ratio for better mobile centering
        const aspectRatio = this.sizes.width / this.sizes.height
        const desktopAspectRatio = 16 / 9
        const xOffset = Math.max(0, (aspectRatio - desktopAspectRatio) * -0.5)
        this.instance.position.set(xOffset, 0, 6)
    }

    setControls()
    {
        this.controls = new OrbitControls(this.instance, this.canvas)
        this.controls.enableDamping = true
    }

    resize()
    {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
        this.updateCameraPosition()
    }

    update()
    {
        this.controls.update()
    }
}